import { useState, useRef, useEffect } from "react";
import './css/AudioRecorder.css';
import microphone from './assets/microphone.png';


const AudioRecorder = ({ saveAudioBlob, saveAudio, audio }) => {
    const mimeType = "audio/mpeg";
    const [permission, setPermission] = useState(false);
    const mediaRecorder = useRef(null);
    const [recordingStatus, setRecordingStatus] = useState("inactive");
    const [stream, setStream] = useState(null);
    const [audioChunks, setAudioChunks] = useState([]);
    const [audioUrl, setAudioUrl] = useState(null);


    const blobToBase64 = (blob) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };

    const getMicrophonePermission = async () => {
        if ("MediaRecorder" in window) {
            try {
                const streamData = await navigator.mediaDevices.getUserMedia({
                    audio: true,
                    video: false,
                });
                setPermission(true);
                setStream(streamData);
            } catch (err) {
                alert(err.message);
            }
        } else {
            alert("The MediaRecorder API is not supported in your browser.");
        }
    };

    const closeMicrophonePermission = async () => {
        const tracks = stream.getTracks();
        tracks.forEach(track=>{
            track.stop()
        })
        setPermission(false);
    };

    const startRecording = async () => {
        setRecordingStatus("recording");
        //create new Media recorder instance using the stream
        const media = new MediaRecorder(stream, { type: mimeType });
        //set the MediaRecorder instance to the mediaRecorder ref
        mediaRecorder.current = media;
        //invokes the start method to start the recording process
        mediaRecorder.current.start();
        let localAudioChunks = [];
        mediaRecorder.current.ondataavailable = (event) => {
            if (typeof event.data === "undefined") return;
            if (event.data.size === 0) return;
            localAudioChunks.push(event.data);
        };
        setAudioChunks(localAudioChunks);
    };

    const stopRecording = () => {
        setRecordingStatus("inactive");
        //stops the recording instance
        mediaRecorder.current.stop();
        mediaRecorder.current.onstop = async () => {
            //creates a blob file from the audiochunks data
            const audioBlob = new Blob(audioChunks, { type: mimeType });
            //creates a playable URL from the blob file.
            const audioUrl = URL.createObjectURL(audioBlob);
            // saveAudioBlob(audioBlob);
            // Convert the Blob to a Base64 string
            const base64Audio = await blobToBase64(audioBlob);
            saveAudio(base64Audio)
            setAudioUrl(audioUrl);
            setAudioChunks([]);
        };
        // console.log('we here yo: ', audioUrl)
    };

    const recordingBttn = () => {
        if(recordingStatus === "recording"){
            document.querySelector('.recording').style.border = "6px solid black";
            stopRecording()
            closeMicrophonePermission()
            return
        }
        if(permission){
            startRecording()
            document.querySelector('.recording').style.border = "6px solid #4490C3";
            return
        }

        getMicrophonePermission()
        // document.querySelector('.recording').style.backgroundColor = "red";
    };
    

    return (
        <div>
            <div style={{ display: 'flex', fontSize: '0.875em', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', width: '100%', marginTop: '2rem' }}>
                <div className = "recordBttn" onClick={recordingBttn}>
                    <div id="recordingContainer" className="recording">
                        <img id="microphone" style={{ width: '40px', maxWidth: '60px', maxHeight: '40px'}} src={microphone} alt="Example" />
                    </div>
                </div>
                {audioUrl ? (
                    <div className="audio-container" style={{ marginTop: '1.5rem'}}>
                        <audio src={audioUrl} controls></audio>
                    </div>
                ) : null}
                <div className="audio-controls">
                    {!permission ? (
                    <div className="text-prompts">
                        Click to Get Microphone
                    </div>
                    ) : null}
                    {permission && recordingStatus === "inactive" ? (
                    <div className="text-prompts">
                        Click to Start Recording
                    </div>
                    ) : null}
                    {recordingStatus === "recording" ? (
                    <div className="text-prompts">
                        Click to Stop Recording
                    </div>
                    ) : null}
                    {/* {permission ? (
                    <div>
                        Done
                    </div>
                    ) : null} */}
                </div>
            </div>
        </div>
    );
};
export default AudioRecorder;